import axios from 'axios';
import React, { useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { fetchClientData } from '../../redux/client/clientSlice';
import api from '../../utils/api';
import socket from '../../context/socket';


const PanCardForm = ({ show, onHide, proofType, kycDoc, roomId }) => {
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const dispatch = useDispatch();
  // Step 1: Extract PAN card data
  const panCardDoc = kycDoc?.find(doc => doc.doctype === "pancard");
  const panData = panCardDoc?.data?.[0] || {};
  console.log("panData",panData)

  useEffect(() => {
    if (panData) {
      setValue("fullName", panData.name || "");
      setValue("birthDate", panData.dob ? panData.dob.split("T")[0] : "");
      setValue("fatherName", panData.fatherName || "");
      setValue("pan", panData.pannumber || "");
      setValue("panType", panData.panType || "");
    }
  }, [panData, setValue]);

  const onSubmit = async (data) => {
    const payload = {
      _id:roomId,
      name: data.fullName,
      dob: data.birthDate,
      father_name: data.fatherName,
      pan: data.pan,
      pan_type: data.panType,
      document_type: 'pancard',
      data_status: true,
    };
    // console.log(payload);
    

    try {
      const response = await api.post(
       "advisor/add_kyc_doc_data",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.status ===200||response?.status===201) {
        Swal.fire({
          icon: "success",
          text: response?.data?.message || "Client data updated successfully",
          title: "Success",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        }).then(() => {
          setValue("");
          onHide();
          dispatch(fetchClientData(roomId));
    
          socket.emit("join", { room: roomId });
          socket.emit("message_to", 
            {
              room: roomId,
              data: { message: response?.message || "Client data updated successfully",
              type: "success",}
            
            })
          console.log("emitted data message_to", roomId, "success");
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: response.data?.message || 'Something went wrong!',
          confirmButtonColor: '#d33',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'API Error',
        text: error.message || 'Something went wrong during submission!',
        confirmButtonColor: '#d33',
      });
    }
  };


  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton style={{ backgroundColor: '#c7e69b' }}>
        <Modal.Title>{proofType} Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            {/* Full Name */}
            <Col md={6}>
              <Form.Group controlId="fullName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter full name"
                  {...register("fullName", { required: "Full Name is required" })}
                  className='refer'
                />
                {errors.fullName && <p className="error text-danger">{errors.fullName.message}</p>}
              </Form.Group>
            </Col>

            {/* Birth Date */}
            <Col md={6}>
              <Form.Group controlId="birthDate">
                <Form.Label>Birth Date</Form.Label>
                <Form.Control
                  type="date"
                  {...register("birthDate", { required: "Birth Date is required" })}
                  className='refer'
                />
                {errors.birthDate && <p className="error text-danger">{errors.birthDate.message}</p>}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Father Name */}
            <Col md={6}>
              <Form.Group controlId="fatherName">
                <Form.Label>Father's Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter father's name"
                  {...register("fatherName", { required: "Father's Name is required" })}
                  className='refer'
                />
                {errors.fatherName && <p className="error text-danger">{errors.fatherName.message}</p>}
              </Form.Group>
            </Col>

            {/* PAN */}
            <Col md={6}>
              <Form.Group controlId="pan">
                <Form.Label>PAN</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter PAN number"
                  {...register("pan", { required: "PAN is required" })}
                  className='refer'
                />
                {errors.pan && <p className="error text-danger">{errors.pan.message}</p>}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* PAN Type */}
            <Col md={6}>
              <Form.Group controlId="panType">
                <Form.Label>PAN Type</Form.Label>
                <Form.Control as="select" {...register("panType", { required: "PAN Type is required" })} className='refer'>
                  <option value="">Select PAN Type</option>
                  <option value="Adult">Adult</option>
                  <option value="Individual">Individual</option>
                  <option value="Company">Company</option>
                  <option value="Firm">Firm</option>
                  <option value="Trust">Trust</option>
                </Form.Control>
                {errors.panType && <p className="error text-danger">{errors.panType.message}</p>}
              </Form.Group>
            </Col>
          </Row>

          <Modal.Footer className='border-0'>
            <Button variant="secondary" onClick={onHide}>
              Close
            </Button>   
            <Button variant="success" type="submit">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PanCardForm;
